import classNames from 'classnames';
import React from 'react';
import { Controller, Control, FieldValues, Path } from 'react-hook-form';

interface Props<T extends FieldValues> {
  name: Path<T>;
  label?: string;
  className?: string;
  error?: string;
  options: { label: string; value: string }[];
  control: Control<T>;
  isRequired?: boolean;
  isDisabled?: boolean;
}

export const ReactiveFormCheckbox = <T extends FieldValues>(props: Props<T>) => {
  return (
    <Controller
      name={props.name}
      control={props.control}
      rules={{ required: props.isRequired ?? false }}
      defaultValue={[] as unknown as T[typeof props.name]}
      render={({ field }) => {
        const value = (field.value ?? []) as string[];
        return (
          <div className={'w-full mb-3 px-3 grid items-end ' + (props.className ?? '')}>
            <label className="block tracking-wide text-gray-700 text-sm mb-2">
              {props.label}
            </label>
            <div className="flex gap-4">
              {props.options.map((option) => (
                <div className="form-check" key={option.value}>
                  <label
                    htmlFor={option.value}
                    className="block tracking-wide text-gray-700 text-xs mb-2"
                  >
                    <input
                      type="checkbox"
                      name={props.name}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        const currentValue = Array.isArray(value) ? value : [];
                        if (isChecked) {
                          field.onChange([...currentValue, option.value]);
                        } else {
                          field.onChange(currentValue.filter((v) => v !== option.value));
                        }
                      }}
                      checked={value.includes(option.value)}
                      value={option.value}
                      disabled={props.isDisabled}
                      className={classNames({
                        'form-check-input mr-2': true,
                        'border-red-500': props.error,
                        'bg-slate-100': props.isDisabled === true,
                      })}
                      id={option.value}
                    />
                    {option.label}
                  </label>
                </div>
              ))}
            </div>
          </div>
        );
      }}
    />
  );
};
